import { r as e, t } from "../../chunks/index.es.rgGZEnOs.js";
import { Transforms as n } from "slate";
//#region lib/List/lib/actionHandler.ts
var r = (r, i) => {
	let a = ["core/unordered-list", "core/ordered-list"].includes(i) ? i : "core/unordered-list", o = t.includes(r, a);
	n.unwrapNodes(r, {
		match: (n) => !t.isEditor(n) && e.isElement(n) && ["core/unordered-list", "core/ordered-list"].includes(n.type),
		split: !0
	});
	let s = {
		type: o ? "core/text" : `${a}/list-item`,
		properties: {}
	};
	n.setNodes(r, s, { match: (n) => !t.isEditor(n) && e.isElement(n) && n.class === "text" }), o || n.wrapNodes(r, {
		id: crypto.randomUUID(),
		class: "text",
		type: a,
		children: []
	});
};
//#endregion
export { r as actionHandler };
